module.exports = __webpack_public_path__ + "img/150.6193e769.png";